import { render, staticRenderFns } from "./edit-asset.vue?vue&type=template&id=584f73db&scoped=true&"
import script from "./edit-asset.vue?vue&type=script&lang=ts&"
export * from "./edit-asset.vue?vue&type=script&lang=ts&"
import style0 from "./edit-asset.vue?vue&type=style&index=0&id=584f73db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f73db",
  null
  
)

export default component.exports